import { useGetCompanyProfile } from "@/api/app/profile/useGetCompanyProfile";
import LoadingScreen from "@/components/Loading";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { handleCompanyName } from "@/lib/handleName";
import AssessmentDateCard from "@/src/_components/AssessmentDateCard";
import CompanyCard from "@/src/_components/CompanyCard";
import AppContentContainer from "@/src/app/(auth)/_components/AppContentContainer";
import MemberCard from "@/src/app/(auth)/profile/_components/MemberCard/MemberCard";
import { LinkRegular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

function Profile() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { data, isLoading } = useGetCompanyProfile();

  if (!data || isLoading) return <LoadingScreen />;

  const { company_users, ...company } = data.data;
  const { id, company_name, homepage_url, start_date, end_date } = company;

  return (
    <AppContentContainer>
      <Tabs defaultValue="company info">
        {/* header */}
        <div className="h-[168px] pt-8 px-32 flex flex-col justify-between border-b border-cool-gray-20">
          {/* company my-heading */}
          <div className="flex flex-col gap-2">
            <div className="text-2xl font-bold">
              {handleCompanyName(id, company_name)}
            </div>
            {homepage_url && (
              <div className="flex items-center gap-1">
                <LinkRegular fontSize={20} />
                <a href={homepage_url} className="text-cyan-600">
                  {homepage_url}
                </a>
              </div>
            )}
          </div>
          {/* tab bar */}
          <TabsList>
            <TabsTrigger value="company info">{t("company-info")}</TabsTrigger>
            <TabsTrigger value="members">{t("company-members")}</TabsTrigger>
          </TabsList>
        </div>
        <div className="py-8 px-32 bg-cool-gray-50">
          <TabsContent className="flex gap-8" value="company info">
            <div className="grow">
              <CompanyCard
                company={company}
                onEdit={() => navigate(`/app/profile/edit`)}
              />
            </div>
            <AssessmentDateCard startDate={start_date} endDate={end_date} />
          </TabsContent>
          <TabsContent value="members">
            <MemberCard members={company_users} />
          </TabsContent>
        </div>
      </Tabs>
    </AppContentContainer>
  );
}

export default Profile;
